import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TopicsSection />
        <IndexSection />
        <RankingSection />
        <FeaturesSection />
        <UpdatesSection />
        <AppSection />
        <ContactSection />
        <FaqSection />
        <AboutSection />
        <CommentsSection />
        <CarouselSection />
        <CardsSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}